import { InlineAlertType, InlineAlertWidget, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';
import { Messages } from '~src/codegen/Localize';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { ISiteCEPPStatusResult, SiteCEPPConfiguration } from '../serverApi/types/IActivityLog';
import { activityLogConnectionSetupDialogBlock, activityLogConnectionSetupDialogComponent, activityLogConnectionSetupSpacer } from '../styles/ActivityLogSettingsStyles';
import { ActivityLogConnectionSetupDialogFields } from './ActivityLogConnectionSetupDialogFields';
import { ACTIVITY_LOG } from './ActivityLogSettings';

export interface ActivityLogConnectionSetupDialogWidgetProps {
    toggleIsEnabled: () => void;
}

export interface ActivityLogConnectionSetupDialogBodyProps {
    configuration: SiteCEPPConfiguration;
    cancel: () => void;
    close: (result: any) => void;
    error?: (errorMsg: string) => void;
    updateStatusCallback: (status: ISiteCEPPStatusResult) => void;
}

export function ActivityLogConnectionSetupDialog(props: ActivityLogConnectionSetupDialogBodyProps) {
    const [error, setError] = React.useState('');

    const connectionSetupDialogInformationWidgetComponent = (): JSX.Element => {
        return <>
        <div>
            {Messages.activityLogConnectionSetupDescription()}
            <TextLinkWidget
                testId={`${ACTIVITY_LOG}-dialog-learn-more`}
                kind={TextLinkKind.Standard}
                className={learnMoreStyle}
                href={HelpService.getHelpUrlByCategory('activity-log-connection-setup')}
                target={'_blank'}
                rel={'noreferrer noopener'}>
                {Messages.learnMore()}
            </TextLinkWidget>
        </div>
        </>;
    };

    const connectionSetupDialogComponent = (): JSX.Element => {
        return <>
            <section>
                <div className={activityLogConnectionSetupDialogBlock}>
                    <div className={activityLogConnectionSetupSpacer}>
                        <InlineAlertWidget
                            children={connectionSetupDialogInformationWidgetComponent()}
                            type={InlineAlertType.Info}
                            testId={`${ACTIVITY_LOG}-dialog-inline-desc`}
                        />
                    </div>
                    {error.length ?
                        <InlineAlertWidget
                            children={error}
                            type={InlineAlertType.Error}
                            testId={`${ACTIVITY_LOG}-dialog-inline-error`}
                    />: null}
                </div>
                <div className={activityLogConnectionSetupDialogBlock}>
                    <div className={activityLogConnectionSetupDialogComponent}>
                        <ActivityLogConnectionSetupDialogFields {...props} error={setError}/>
                    </div>
                </div>
            </section>
        </>;
    };

    return connectionSetupDialogComponent();
}

export default ActivityLogConnectionSetupDialog;
